// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"131":"99b4f446","308":"9621ff63","563":"9621ff63","720":"7528582a"}[chunkId] + ".chunk.css";
};